export default "__VITE_ASSET__3e5be775__"